import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/lib/i18n";
import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Logo } from "@/components/shared/Logo";
import { ArrowLeft, Shield } from "lucide-react";

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sections = [
    { key: "controller", num: "1" },
    { key: "data_collected", num: "2" },
    { key: "purposes", num: "3" },
    { key: "legal_bases", num: "4" },
    { key: "sharing", num: "5" },
    { key: "ai", num: "6" },
    { key: "international", num: "7" },
    { key: "retention", num: "8" },
    { key: "rights", num: "9" },
    { key: "cookies", num: "10" },
    { key: "security", num: "11" },
    { key: "children", num: "12" },
    { key: "changes", num: "13" },
    { key: "contact", num: "14" },
  ];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy-page">
      <header className="bg-navy-900 border-b border-navy-800">
        <div className="max-w-4xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
          <div onClick={() => navigate("/")}><Logo size="md" className="text-white cursor-pointer" /></div>
          <LanguageSelector variant="dark" />
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
        <Button variant="ghost" className="mb-4 text-slate-600 font-body" onClick={() => navigate(-1)} data-testid="privacy-back-btn">
          <ArrowLeft className="w-4 h-4 mr-2" /> {t("privacy.back")}
        </Button>
        <Card className="bg-white border-slate-200 shadow-sm">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-3 mb-2">
              <Shield className="w-8 h-8 text-gold-500" />
              <div>
                <CardTitle className="font-sans text-2xl text-slate-900">{t("pp.title")}</CardTitle>
                <p className="text-sm text-slate-500 font-body">{t("pp.version")}</p>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6 font-body text-slate-700 text-sm leading-relaxed">
            <p>{t("pp.intro")}</p>
            {sections.map(({ key, num }) => (
              <div key={key}>
                <h3 className="font-sans font-semibold text-base text-slate-900 mb-2">{num}. {t(`pp.${key}_t`)}</h3>
                <div className="whitespace-pre-line">{t(`pp.${key}`)}</div>
              </div>
            ))}
            <div className="pt-4 border-t border-slate-200">
              <p className="text-xs text-slate-400">{t("pp.footer")}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
